import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import { AxiosInstance, END_POINTS } from '../../integrations'

export const checkUserFdwAcc = createAsyncThunk(
    'get/checkUserLink',
    async (MockAccId?: string | undefined | null) => {
        let userKey = window.localStorage.getItem('MOCK_ACC_ID')
        if (MockAccId) {
            userKey = MockAccId
        }

        try {
            const response: userLinkAcc = await AxiosInstance.get(
                `${END_POINTS.checkUserLink}/3`
            )
            return response
        } catch (error: any) {
            return error.message
        }
    }
)

export const claimNft = createAsyncThunk(
    'get/claimNft',
    async (poolId: number) => {
        let userKey = window.localStorage.getItem('MOCK_ACC_ID')

        try {
            const response: userLinkAcc = await AxiosInstance.post(
                `${END_POINTS.seasonStatusApi}/${userKey}/prizes/${poolId}/claim`
            )
            return response
        } catch (error: any) {
            return error.message
        }
    }
)

export const getSeasonRewards = createAsyncThunk(
    'get/getUserRewards',
    async (MockAccId?: string | undefined | null) => {
        let userKey = window.localStorage.getItem('MOCK_ACC_ID')
        const seasonKeyword = window.localStorage.getItem(
            'SEASON_KEYWORD_CONFIG'
        )
        if (MockAccId) {
            userKey = MockAccId
        }

        try {
            const response: userLinkAcc = await AxiosInstance.get(
                `${END_POINTS.seasonStatusApi}/${userKey}/prizes?seasonKey=${seasonKeyword}&version=mock`
            )
            return response
        } catch (error: any) {
            return error.message
        }
    }
)

const initialState: seasonSummaryState = {
    status: 'idle',
}

export const seasonStatusSlice = createSlice({
    name: 'seasonStatus',
    initialState,
    reducers: {},
    extraReducers(buidler) {
        buidler
            .addCase(checkUserFdwAcc.pending, (state, action) => {
                state.status = 'pending'
            })
            .addCase(checkUserFdwAcc.fulfilled, (state, action) => {
                state.status = 'success'
                state.linkAccount = action.payload
            })
            .addCase(getSeasonRewards.pending, (state, action) => {
                state.status = 'pending'
            })
            .addCase(getSeasonRewards.fulfilled, (state, action) => {
                state.status = 'success'
                state.userInfo = action.payload
            })
            .addCase(claimNft.pending, (state, action) => {
                state.status = 'pending'
            })
            .addCase(claimNft.fulfilled, (state, action) => {
                state.status = 'success'
                state.claim = action.payload
            })
    },
})

export default seasonStatusSlice.reducer
